import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ListSubheader from '@material-ui/core/ListSubheader';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import { useSnackbar } from 'notistack';
import './MultipleSelectCheckmarks.css';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function MultipleSelectCheckmarks({
    serverList = [],
    selectedServers = [],
    onSelectionChange = () => {},
    onApply = () => {},
    corporationDetail = {},
    isEnableMcpInVersion = true,
    handleCloseMcpServerMenu = () => {}
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    React.useEffect(() => {}, [selectedServers]);

    const handleToggleServer = (serverId) => {
        const currentIndex = selectedServers.indexOf(serverId);
        const newSelected = [...selectedServers];

        if (currentIndex === -1) {
            newSelected.push(serverId);
        } else {
            newSelected.splice(currentIndex, 1);
        }

        onSelectionChange(newSelected);
    };

    const handleOpen = (event) => {
        if (!serverList || serverList.length === 0) {
            return;
        }

        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        handleCloseMcpServerMenu()
    };

    return (
        <div
            className="multiple-select-checkmarks-wrapper"
            data-component="multiple-select-checkmarks"
        >
            <Tooltip title="外部連携選択" placement="top" arrow enterDelay={300} leaveDelay={0}>
                <span
                    className="mcp-logo"
                    onClick={handleOpen}
                    style={{
                        cursor: serverList && serverList.length > 0 ? 'pointer' : 'not-allowed',
                        opacity: serverList && serverList.length > 0 ? 1 : 0.5,
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleOpen(e);
                        }
                    }}
                    aria-label="MCP Server Selection"
                >
                    {I18n.get('MCP_SERVER_SETTING_TEXT_ICON')}
                </span>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    className: 'multiple-select-menu-paper',
                    'data-component': 'multiple-select-checkmarks',
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                        width: 200,
                        marginTop: 8,
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                getContentAnchorEl={null}
            >
                {serverList?.filter(server => server.type !== Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL)?.length > 0 && (
                <>
                <div className='list-mcp-subheader list-mcp-project'>プロジェクト用</div>
                {serverList?.filter(server => server.type !== Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL)?.map((server) => (
                    <MenuItem
                        key={server.id}
                        onClick={() => handleToggleServer(server.id)}
                        className="multiple-select-menu-item"
                    >
                        <Checkbox
                            checked={selectedServers.indexOf(server.id) > -1}
                            className="multiple-select-checkbox"
                        />
                        <Tooltip
                            title={Utils.serverNameWithPrefix(server.name, server.type)}
                            placement="right"
                            arrow
                            enterDelay={300}
                            leaveDelay={0}
                        >
                            <ListItemText
                                primary={Utils.serverNameWithPrefix(server.name, server.type)}
                            />
                        </Tooltip>
                    </MenuItem>
                    ))}
                    </>
                )}
                {/* comment personal connector */}
                {/* <>
                <div className='list-mcp-subheader list-mcp-project'>個人用</div>
                {serverList?.filter(server => server.type === Constant.MCP_SERVER_TYPE.OPENAI_CONNECTOR_PERSONAL)?.map((server) => (
                    <MenuItem
                        key={server.id}
                        onClick={() => handleToggleServer(server.id)}
                        className="multiple-select-menu-item"
                    >
                        <Checkbox
                            checked={selectedServers.indexOf(server.id) > -1}
                            className="multiple-select-checkbox"
                        />
                        <Tooltip
                            title={Utils.serverNameWithPrefix(server.name, server.type)}
                            placement="right"
                            arrow
                            enterDelay={300}
                            leaveDelay={0}
                        >
                            <ListItemText
                                primary={Utils.serverNameWithPrefix(server.name, server.type)}
                            />
                        </Tooltip>
                    </MenuItem>
                ))}
                </> */}
            </Menu>
        </div>
    );
}

// PropTypes definition
MultipleSelectCheckmarks.propTypes = {
    serverList: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
        })
    ),
    selectedServers: PropTypes.array,
    onSelectionChange: PropTypes.func,
    onApply: PropTypes.func,
    corporationDetail: PropTypes.object,
    isEnableMcpInVersion: PropTypes.bool,
};

export default MultipleSelectCheckmarks;
